import React, { useEffect, useState } from 'react';
import { WordCloudWidget } from './index';
import { NonIdealState } from '@blueprintjs/core';
import { DefaultChartColorScales } from 'styles/chartColors';
import { NO_DATA_MESSAGE } from 'widgets/chartUtils';
import { WCWord } from './types'

/**
 * ChartWrapper for the Word Cloud Chart.
 * 
 * Displays no data message if there isn't any data,
 * otherwise displays WordCloudWidget
 *
 * @param getColorScale
 * @param dimensions
 * @param data
 * @param widgetConfiguration
 * @returns {*}
 * @constructor
 */
export function WordCloudWrapper({ getColorScale, dimensions, data, widgetConfiguration, noDataMessage=NO_DATA_MESSAGE }) {
	const [convertedData, setConvertedData] = useState(null);

	// Set up/refresh color scale and data
	useEffect(()=> {
		const keys=data?.entries.map(d=>d.key)
		const converted:WCWord[] = []
		if(!data.entries) return;
		
		
		// Set colors depending on type of data
		let getColor: (d,i)=>any
		if (widgetConfiguration?.colorScale === DefaultChartColorScales.Sequential) {
			getColorScale.domain([0, keys.length || 0]);
			getColor = (_, i) => getColorScale(i)
		} else {
			getColorScale.domain(keys);
			getColor = (d, _) => getColorScale(d.key)
		}

		// Correctly format data
		data.entries.forEach((d,i) => {
			converted.push({
				text:d.key,
				color:getColor(d,i),
				relSize:d.count,
			})
		});
		setConvertedData(converted)
	},[data, getColorScale, widgetConfiguration])

	return convertedData?.length > 0 ? (
		<WordCloudWidget data={convertedData} 
						 dimensions={dimensions} 
						 widgetConfiguration={widgetConfiguration} />
	) : (
		<NonIdealState
			title="No Data Found"
			icon="graph-remove"
			description={noDataMessage}
		/>
	);
}
